import { MetaService } from '../../wikkllibrary-angular/services/meta.service';

export const resetMeta = (metaService: MetaService) => {
  const title = 'New Heights Game: Realistic Climbing & Bouldering - Video Games - Wikkl Works';
  const description = `Get ready to experience the ultimate climbing and bouldering game with New Heights. Made by real climbers for climbing and bouldering enthusiasts, New Heights offers a realistic and immersive climbing and bouldering experience that will put your skills to the test. With scanned real cliffs and structures, you'll feel like you're really there, tackling the toughest climbing and bouldering challenges.`;

  metaService.setTitle(title);
  metaService.setDescription(description);
  metaService.setKeywordsByString(
    'New Heights Game, climbing game, bouldering game, rock climbing game, mountain climbing game, free solo climbing game, mountaineering game, climbing, bouldering, video game, Wikkl Works'
  );
  metaService.removeCustomTagByName('author');
  metaService.removeCustomTagByProperty('article:author');
  metaService.removeCustomTagByProperty('article:published_time');
  metaService.removeCustomTagByProperty('article:modified_time ');
  metaService.removeCustomTagByProperty('article:tag');
};
